export default __webpack_public_path__ + "static/media/AFSA.98d007c5.jpg";